import React, { Component } from 'react';
import './Acquistuato.css';
//import ovaz from '../../images/public/registeration/greenTick.png';
import trueImg from '../../images/public/registeration/true.png';
//import aecs from '../../images/public/registeration/aecs.png';
//import qrla from '../../images/public/registeration/qrla.png';
import pencil from '../../images/public/pencil.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { BrowserView, MobileView } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
import tr from '../../libs/tr';
import {userFetch} from '../../libs/fetch';
import Cookies from 'universal-cookie';
//import itabar4 from '../../images/public/registeration/nav4i.png';
//import engbar4 from '../../images/public/registeration/nav4e.png';
//import simplebar4 from '../../images/public/registeration/mobilenav4.png';
import TopBar from '../../assets/components/topbar/TopBar';
//import back from '../../images/public/registeration/back.png';
import logo from '../../images/public/login/logo.png';
//import miniArrow from '../../images/public/registeration/miniarrow.png';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';

const cookies = new Cookies();
class Acquistuato extends Component {
	constructor(props) {
		super(props);
		let params = null;
		//console.log('[Acquistuato]', params);

		this.state = {
			step: '4',
			isShipment: false,
			notice_title:'',
			notice:'',
			receiver:'',
			delivery1:'',
			delivery2:'',
			delivery3:'',
		}
	}

	componentDidMount() {
		localStorage.setItem("confirmedvoucher_code", null);
		localStorage.setItem("totalPrice", null);
		localStorage.setItem("cart", null);
		localStorage.setItem("price_info", null);
		this.getPostalInfo()
	}

	ifIsShipment=()=> {
		let cart = JSON.parse(localStorage.getItem("purchaseCart"))
		localStorage.setItem("purchaseCart", null);
		for (var x in cart) {
			if (cart[x].shipment == "1") return true;
		}
		return false;
	}
	gotoUserarea = (e) => {
		e.preventDefault();
		//console.log("[Acquistuato] @gotoUserarea");
		return this.props.history.push('/userarea');
	}

	onEditClicked = () => {
		localStorage.setItem("updateAndGoToHome", true);
		return this.props.history.push('/Indirizione');
	}    

	getPostalInfo = ()=>{
		let user = JSON.parse(localStorage.getItem('user'));
		//console.log('[Acquistuato] @user: ', user);

		if (!!user) {
			let access_token = cookies.get('access_token');
			let params = { access_token: access_token };
			userFetch(this, params)
				.then((response) => {
					//console.log("[Acquistuato] userFetch @response: ", response);
					if (response.id_ut) {
						localStorage.setItem('user', JSON.stringify(response));
						this.setState(
						{
							isShipment: this.ifIsShipment(),
							notice_title: tr.t('standardPost'),
							notice: tr.t('withinFourDays'),
							receiver: (response.name + ' '+ response.surname).toUpperCase(),
							delivery1: response.address+' '+ response.address2,
							delivery2: response.zipcode + ' ' + response.province.provincia,
							delivery3: response.country.paese,
						}
						)                        
					}
					else {
						this.setState({
							errorFlg: true,
							errmsg: "ERROR!"
						});
					}
				});
		}
	}

	render() {
		return (
			<div>             
				<BrowserView>
					<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
						<div className="row">
							<div className="col-12 d-flex align-items-center justify-content-center">
								<img className="sn_mobile_top_row_logo" src={ logo } />
							</div>
						</div>
					</div>
					<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
					<div className="sn_overlay d-lg-none"></div>
					<div className="sn_bought">
						<div className="container">
							<div className="row">
								<div className="col-12 col-lg-9 mx-auto">
									<div className="sn_register__container d-flex align-items-center flex-column">
										<div className="sn_bought__container__image mb-5">
												<img src={ trueImg } alt=""/>
										</div>
										<h3 className="text-center mb-5">{ tr.t("Purchasedone") }</h3>
										{
											this.state.isShipment &&
											<div className="sn_descAddress">
												<h5><b>{ this.state.notice_title }</b></h5>
												<h6 className="mb-4">{ this.state.notice }</h6>
												<h5><b>{ this.state.receiver }</b></h5>
												<p>
													{ this.state.delivery1 }
													<br/>
													{ this.state.delivery2 }
													<br/>
													{ this.state.delivery3 }
												</p>
												<div className="sn_pencil">
													<a onClick={()=>{this.onEditClicked()}}>
														<img src={ pencil }/>
													</a>
												</div>
											</div>
										}
										<button disabled={false} onClick={this.gotoUserarea} className="sn_btn mt-5">
											{ tr.t("Goto") }
										</button>
										<div className="row d-lg-none mt-5">
											<div className="col-12">
												<ProgressBullets step={ this.state.step } />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</BrowserView>
				<MobileView>
				<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
						<div className="row">
							<div className="col-12 d-flex align-items-center justify-content-center">
								<img className="sn_mobile_top_row_logo" src={ logo } />
							</div>
						</div>
					</div>
					<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
					<div className="sn_overlay d-lg-none"></div>
					<div className="sn_bought">
						<div className="container">
							<div className="row">
								<div className="col-12 col-lg-9 mx-auto">
									<div className="sn_register__container d-flex align-items-center flex-column">
										<div className="sn_bought__container__image mb-5">
												<img src={ trueImg } alt=""/>
										</div>
										<h3 className="text-center">{ tr.t("Purchasedone") }</h3>
										{
											this.state.isShipment &&
											<div>
												<h5>{ this.state.notice_title }</h5>
												<h6>{ this.state.notice }</h6>
												<h5>{ this.state.receiver }</h5>
												<p>
													{ this.state.delivery1 }
													<br/>
													{ this.state.delivery2 }
													<br/>
													{ this.state.delivery3 }
												</p>
												<div className="sn_pencil">
													<a onClick={()=>{this.onEditClicked()}}>
														<img src={ pencil }/>
													</a>
												</div>
											</div>
										}
										<button onClick={this.gotoUserarea} className="sn_btn mt-4">
											{ tr.t("Goto") }
										</button>
										<div className="row d-lg-none mt-5">
											<div className="col-12">
												<ProgressBullets step={ this.state.step } />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</MobileView>
			</div>
		);
	}
}

export default Acquistuato;


// WEBPACK FOOTER //
// ./src/screens/Acquistuato/Acquistuato.js